// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3OasN","disabled":"FileBtn_disabled__uZgX6","warn":"FileBtn_warn__O4iT9","fade":"FileBtn_fade__vfeI1"};